/*
 * Lib Module Test
 */

Lib.Test = (function() {
    var self = {};


    var tests = ['numberFormatting'];

    self.runAll = function(log) {
        log = log || false;

        if (log) {
            Lib.Debug.allowMessages();
        } else {
            Lib.Debug.blockMessages();
        }

        var failedTests = [], successTests = [];

        $.each(tests, function(i, testName) {
            var testResult = self.run(testName);
            if (testResult !== true) {
                failedTests.push({name: testName, result: testResult});
            } else {
                successTests.push(testName);
            }
        });

        Lib.Debug.allowMessages();


        if (failedTests.length > 0) {
            Lib.Debug.log('%cNot all tests succeeded', 'background: #222; color: red; font-size: 17px;');


            Lib.Debug.log('%cTest results: ', 'background: #222; color: red; font-size: 17px;');

            $.each(failedTests, function(i, test) {
                Lib.Debug.log('%c❌ ' + test.name + ': ' + test.result, 'background: #222; color: red; font-size: 17px;');
            });

            if (successTests.length > 0) {
                $.each(successTests, function(i, test) {
                    Lib.Debug.log('%c✅ ' + test, 'background: #222; color: green; font-size: 17px;');
                });
            }
        } else {
            Lib.Debug.log('%c✅ All tests finished successfully', 'background: #222; color: green; font-size: 17px;');
        }
    };

    self.run = function(testName) {

        Lib.Debug.log('%c########### STARTING TEST `' + testName + '` ###########', 'background: #ffffff; color: blue; font-size: 17px;');
        Lib.Benchmark.start('test' + testName);

        result = false;

        if (typeof self[testName] === 'function') {
            var result = self[testName]();

            if (result === true) {
                Lib.Debug.log('%c✅ Test successful', 'background: #222; color: green; font-size: 17px;');
            } else {
                Lib.Debug.log('%c❌ Test failed: ' + result, 'background: #222; color: orange; font-size: 17px;');
            }

        }
        var timeTaken = Lib.Benchmark.stop('test' + testName);
        Lib.Debug.log('%c########### ENDING TEST `' + testName + '` (took ' + timeTaken + 'ms) ###########', 'background: #ffffff; color: blue; font-size: 17px;');

        return result;
    };

    self.successTest = function() {
        return true;
    };

    self.failTest = function() {
        return 'This one failed!';
    };


    self.numberFormatting = function() {

        var nums = [
            1,
            10,
            100,
            1000,
            10000,
            100000,
            1000000,
            10000000,
            100000000,
            1000000000,
            10000000000,
            100000000000,
            1000000000000,
            10000000000000,
            100000000000000,
            1.00,
            1.50,
            10.00,
            10.50,
            10.99,
            100.10,
            1000.10,
            '1',
            '10',
            '100',
            '1000',
            '10000',
            '100000',
            '1000000',
            '10000000',
            '100000000',
            '1000000000',
            '10000000000',
            '100000000000',
            '1000000000000',
            '10000000000000',
            '100000000000000',
            '1.00',
            '1.50',
            '10.00',
            '10.50',
            '10.99',
            '100.10',
            '1000.10',
            '1.00,0',
            '1.50,0',
            '10.00,0',
            '10.50,0',
            '10.99,0',
            '100.10,0',
            '1000.10,0',
            '1.234.567.8',
            '1.234.567.8,50',
            '1.234.567.8,5056',
            '340.560',
            '340560,34',
            '340.560,34',
            '340,560.34',
            '1.123',
            '10,123',
            '10.123',
            '1,23',
            '1.23',
            '123.456',
            '123,456',
            '1.234,56',
            '1.000.000',
            'abc',
            ',00',
            '.00',
            ',',
            '.',
            'ab.cd',
            '.abc',
            '-5',
            '-3,60',
            '-1.000.000,45'
        ];

        try {
            nums.map(function(num) {
                Lib.Debug.log(num);
                Lib.Debug.log(Lib.Format.cleanNumber(num));
                Lib.Debug.log('-----');
            });
            return true;
        } catch (e) {
            return 'Failed formatting numbers';
        }
    };


    return self;
})();
